import Common from "../common/Common";
import Swiper from "swiper/bundle";

class Top1 {
  constructor() {
    this.common = new Common();
    this.slide1 = document.querySelector(".p-top-article-list2");
    this.element1 = document.querySelector(".p-top-article-list2 .swiper");
    this.mediaQueryList = this.common.matchMedia("md");
    this.swiper1 = null;

    this.initialize();
    this.mediaQueryList.addEventListener("change", this.initialize.bind(this));
  }

  initialize() {
    if (this.slide1) {
      if (this.mediaQueryList.matches) {
        this.slidePickup();
      } else {
        if (this.swiper1 !== null) {
          this.swiper1.destroy();
          this.swiper1 = null;
        }
      }
    }
  }

  slidePickup() {
    this.swiper1 = new Swiper(this.element1, {
      speed: 1000,
      spaceBetween: 20,
      slidesPerView: 1,
      loop: true,
      //autoplay: true,
      loopAdditionalSlides: 1,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.element1.querySelector(".swiper-button-next"),
        prevEl: this.element1.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.element1.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }
}

export default Top1;
